<!-- 没有组合column -->
<div *ngIf="!column.combinedColumns?.length" class="flex-start-center gap-x-1 select-none">
    <div>{{ column.name }}</div>
    <span *ngIf="column.info" nz-icon nzType="info-circle" [nz-tooltip]="column.info" class="text-xs text-sub-text"></span>
    <app-table-sorter *ngIf="column.showSorter" [(sortOrder)]="column.sortOrder" (sortOrderChange)="customSortChange(column)"></app-table-sorter>

    <nz-filter-trigger *ngIf="column.showFilter" [nzActive]="isFilterActive(column)" [nzDropdownMenu]="menu" (nzVisibleChange)="filterVisibleChange(column)">
        <span nz-icon nzType="filter" nzTheme="fill"></span>
    </nz-filter-trigger>
</div>

<!-- 有组合column -->
<div *ngIf="column.combinedColumns?.length" class="flex-start-center gap-x-1 select-none">
    <div *ngFor="let combinedColumn of column.combinedColumns;let last = last" class="whitespace-nowrap flex-start-center gap-x-1">
        <div>{{ combinedColumn.name }}</div>
        <span *ngIf="combinedColumn.info" nz-icon nzType="info-circle" [nz-tooltip]="combinedColumn.info" class="text-xs text-sub-text"></span>

        <app-table-sorter
            *ngIf="combinedColumn.showSorter"
            [(sortOrder)]="combinedColumn.sortOrder"
            (sortOrderChange)="customSortChange(combinedColumn)"
        ></app-table-sorter>

        <nz-filter-trigger
            *ngIf="combinedColumn.showFilter"
            [nzActive]="isFilterActive(combinedColumn)"
            [nzDropdownMenu]="menu"
            (nzVisibleChange)="filterVisibleChange(combinedColumn)"
        >
            <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>

        <div *ngIf="!last && column.splitBetweenCombinedColumns" class="text-xs">{{column.splitBetweenCombinedColumns}}</div>
    </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown w-[260px]">
        <div *ngIf="selectedColumn" class="px-3 py-2 space-y-3">
            <div class="text-xs text-sub-text">{{ selectedColumn?.filterBoxName || selectedColumn?.name }}</div>

            <div *ngIf="selectedColumn.quickOptions" class="flex-start-center gap-x-2">
                <div
                    *ngFor="let option of $any(selectedColumn.quickOptions)"
                    class="flex-1 h-[28px] rounded border-line border flex-center-center text-center text-xs cursor-pointer hover:bg-black hover:bg-opacity-6"
                    [ngStyle]="option.style"
                    [ngClass]="{'bg-black bg-opacity-6':option.value === $any(filterData)}"
                    (click)="applyQuickOption(option)"
                >
                    <div>{{option.name}}</div>
                </div>
            </div>

            <div *ngIf="selectedColumn.filterType === 'numberRange'">
                <div class="flex-between-center gap-x-2 text-xs">
                    <div class="relative">
                        <input type="number" nzSize="small" [(ngModel)]="$any(filterData)[0]" nz-input class="h-[28px] !rounded !border-line !text-xs" />

                        <div *ngIf="selectedColumn.inputSuffix" class="absolute right-1 top-0 text-xs text-sub-text h-full flex-center-center">
                            {{selectedColumn.inputSuffix}}
                        </div>
                    </div>

                    <span>to</span>

                    <div class="relative">
                        <input type="number" nzSize="small" [(ngModel)]="$any(filterData)[1]" nz-input class="h-[28px] !rounded !border-line !text-xs" />

                        <div *ngIf="selectedColumn.inputSuffix" class="absolute right-1 top-0 text-xs text-sub-text h-full flex-center-center">
                            {{selectedColumn.inputSuffix}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-between-center gap-x-2">
                <button nz-button nzSize="small" class="flex-1 h-[28px]" (click)="reset()">Reset</button>
                <button nz-button nzSize="small" nzType="primary" class="flex-1 h-[28px]" (click)="applyFilter()">
                    <span class="colorful-text">Apply</span>
                </button>
            </div>
        </div>
    </div>
</nz-dropdown-menu>
